// src/components/PageWithTitle/PageWithTitle.tsx

import React, { ReactElement, useEffect } from "react";
import { useTitle } from "../../contexts/TitleContext/TitleContext";

interface PageWithTitleProps {
    title: string;
    element: ReactElement;
}

const PageWithTitle = ({ title, element }: PageWithTitleProps) => {
    const { setTitle } = useTitle();

    useEffect(() => {
        setTitle(`${title} | Turnieje Darta`);
        return () => setTitle("Turnieje Darta");
    }, [title, setTitle]);

    return element;
};

export default PageWithTitle;
